import $ from 'jquery';
import assign from 'lodash/object/assign';
import bindAll from 'lodash/function/bindAll';
import has from 'lodash/object/has';

import {init as initLightboxes} from './view/components/lightbox';
import * as BaseModel from './model/BaseModel';

// Configure a dynamic require function to allow requiring any of the Page
// modules at runtime.
const dynamicRequire = require.context('.', true, /^\.\/view\/[^\/]+Page$/);

const PAGES = {
    'portal': 'PortalPage',
    'exhibition': 'ExhibitionMaterialsPage',
    'map': 'ExhibitionMaterialsPage',
    'timeline': 'ExhibitionMaterialsPage',
    'exhibition-detail': 'ExhibitionDetailPage',
    'btspost': 'BehindTheScenesPage',
    'btsindex': 'BehindTheScenesHomePage',
    '360-viewer': 'ThreeSixtyViewerPage'
};

export class Application {
    constructor() {
        this.initialize();
    }

    initialize() {
        bindAll(this, [
            'clickBtnToTop',
            'clickBtnMobileLocalNavToggle',
            'clickBtnToggleCodeInput',
            'touchMoveBackdrop',
            'resizeHandler',
            'modelChangedHandler'
        ]);

        this.$el = $('body');
        this.model = new BaseModel.BaseModel();

        // Initialise the appropreate page object for the current page
        var pageId = this.$el.attr('id');

        if (has(PAGES, pageId)) {
            var pageClass = dynamicRequire('./view/' + PAGES[pageId]);
            this.page = new pageClass({
                appModel: this.model
            });
        }

        this.bindEvents();
        this.updateModelMediaQuery();
        initLightboxes();
    }

    bindEvents() {
        this.$el.on('click', '.js-btn-to-top', this.clickBtnToTop);
        this.$el.on('click', '.js-local-nav .js-mobile .js-btn-toggle', this.clickBtnMobileLocalNavToggle);
        this.$el.on('click', '.js-btn-toggle-code-input', this.clickBtnToggleCodeInput);

        this.$el.on('touchmove', '.js-backdrop', this.touchMoveBackdrop);

        $(window).on('resize', this.resizeHandler);

        this.model.on('change', this.modelChangedHandler);
    }

    modelChangedHandler() {
        if (this.model.isChanged('deviceType')) {
            this.deviceTypeChangedHandler();
        }

        if (this.model.isChanged('mediaQuery')) {
            this.mediaQueryChangedHandler();
        }

        if (this.model.isChanged('backdropped')) {
            this.backdroppedChangedHandler();
        }
    }

    clickBtnToggleCodeInput(e) {
        this.toggleCodeInput();
    }

    mediaQueryChangedHandler() {
        if (this.model.get('mediaQuery') === 'largeLandscape') {
            $('.js-local-nav ul').removeAttr('style');
            this.$el.find('.js-code-input').removeAttr('style').data('shown', false);
        }
    }

    deviceTypeChangedHandler() {
        if (this.model.get('deviceType') === 'mobile') {
            $('.js-hero, .js-detail-sidebar').removeAttr('style');
        }
        this.model.set('backdropped', false);
    }

    backdroppedChangedHandler() {
        var backdropped = this.model.get('backdropped');

        if (backdropped === true) {
            this.$el.prepend($('<div class="backdrop js-backdrop" />'));
        } else {
            this.$el.find('.js-backdrop').remove();
        }

        this.$el.toggleClass('backdropped', backdropped);
    }

    clickBtnMobileLocalNavToggle(event) {
        this.toggleLocalMobileNavigation();
        event.preventDefault();
    }


    clickBtnToTop(event) {
        this.scrollToTop(150);
        event.preventDefault();
    }

    resizeHandler(event) {
        this.updateModelMediaQuery();
    }

    touchMoveBackdrop(event) {
        event.preventDefault();
    }

    toggleLocalMobileNavigation() {
        this.$el.find('.js-local-nav ul').slideToggle('fast');
    }

    getMediaQueryForWidth(width) {
        var query = 'largeLandscape';

        if (width <= 420) {
            query = 'smallPortrait';
        } else if (width <= 767) {
            query = 'smallLandscape';
        } else if (width <= 960) {
            query = 'largePortrait';
        }

        return query;
    }

    getDeviceModeForMediaQuery(mediaQuery) {
        var mode = 'desktop';
        if (mediaQuery === 'smallLandscape' || mediaQuery === 'smallPortrait') {
            mode = 'mobile';
        }
        return mode;
    }

    updateModelMediaQuery() {
        var currentMediaQuery = this.model.get('mediaQuery'),
            newMediaQuery = this.getMediaQueryForWidth(document.documentElement.clientWidth);

        if (newMediaQuery !== currentMediaQuery) {
            this.model.set({
                mediaQuery: newMediaQuery,
                deviceType: this.getDeviceModeForMediaQuery(newMediaQuery)
            });
        }
    }

    toggleCodeInput(show, animated) {
        var $codeInput = this.$el.find('.js-code-input'),
            currentlyShown = $codeInput.data('shown'),
            animateTo;


        show = show !== undefined ? show : !currentlyShown;
        animated = animated !== undefined ? animated : true;

        if (show !== currentlyShown) {

            animateTo = {
                bottom: show === true ? 0 : -$codeInput.find('form').outerHeight()
            };

            if (animated === true) {
                $codeInput.animate(animateTo, 150);
            } else {
                $codeInput.css(animateTo);
            }

            $codeInput.data('shown', show);
        }
    }

    scrollToTop(animationTime, callback) {
        if (animationTime) {
            $('body, html').animate({
                'scrollTop': 0
            }, animationTime, callback);
        } else {
            $('body, html').scrollTop(0);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./js/Application.js
 **/